import QuantityProduct from './QuantityProduct'

class FacadePhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 1
}

export default FacadePhotoProduct
